import { useTranslation } from "react-i18next";

import { useConfig } from "./ConfigProvider";
import { getAnimation } from "./screensaver/Screensaver";
import { RootStateKind, useRootState } from "./state/StateProvider";
import * as svg from "./svg";
import { ActionKind } from "../types/Action";
import useBarcodeScanner, {
    requiresOperatorBadgeScan
} from "./hooks/useBarcodeScanner";

export const OutOfOrder = () => {
    const { state, dispatch } = useRootState(RootStateKind.OutOfOrder);

    const { t } = useTranslation();
    const { tenant } = useConfig();

    useBarcodeScanner({
        onScan: (code) => {
            if (requiresOperatorBadgeScan(state)) {
                dispatch({
                    kind: ActionKind.ScanOperatorBadge,
                    scannedBadge: code
                });
            }
        }
    });

    return (
        <div
            className="flex h-full flex-1 flex-col items-center justify-end pb-32"
            data-testid="out-of-order"
        >
            {getAnimation(tenant)}
            <div className="z-10 m-20 rounded-cta bg-primary-100 bg-opacity-80 p-8 backdrop-blur-lg">
                <div className="grid place-items-center text-secondary-500">
                    {svg.outOfOrder}
                </div>
                <div className="mb-3 text-center text-2xl font-bold text-primary-800">
                    {t("outOfOrder.title")}
                </div>
                <div>{t("outOfOrder.subtitle")}</div>
            </div>
        </div>
    );
};
